/**
 * @generated SignedSource<<9e6559b0e1cd1343158563d028729842>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useToggleCheckActionItem_Mutation$variables = {
  actionItemId: string;
};
export type useToggleCheckActionItem_Mutation$data = {
  readonly toggleCheckActionItem: {
    readonly actionItem: {
      readonly checked: boolean | null;
    } | null;
  } | null;
};
export type useToggleCheckActionItem_Mutation = {
  response: useToggleCheckActionItem_Mutation$data;
  variables: useToggleCheckActionItem_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "actionItemId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "actionItemId",
    "variableName": "actionItemId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "checked",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useToggleCheckActionItem_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleCheckActionItemMutation",
        "kind": "LinkedField",
        "name": "toggleCheckActionItem",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ActionItemNode",
            "kind": "LinkedField",
            "name": "actionItem",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useToggleCheckActionItem_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleCheckActionItemMutation",
        "kind": "LinkedField",
        "name": "toggleCheckActionItem",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ActionItemNode",
            "kind": "LinkedField",
            "name": "actionItem",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d80e00339550786e4b10cb9d9e1fef6b",
    "id": null,
    "metadata": {},
    "name": "useToggleCheckActionItem_Mutation",
    "operationKind": "mutation",
    "text": "mutation useToggleCheckActionItem_Mutation(\n  $actionItemId: ID!\n) {\n  toggleCheckActionItem(actionItemId: $actionItemId) {\n    actionItem {\n      checked\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4219b0526fb0fc4053cba1e8813b914e";

export default node;
